// Unpublished Work © 2020-2025 Deere & Company.

import t from 'tcomb';

import {User} from './struct/user/user';
import {CustomerProfile} from './struct/profile';
import {CustomerSearch} from './struct/customer-search/customer-search';
import {AddCustomerDetail} from './struct/add-customer/add-customer-detail';
import {Configuration} from './struct/configuration';
import {CustomerIds} from './struct/customer-ids';
import {SelectBusinessContact} from './struct/select-business-contact';
import {DbsCustomerProfile} from './struct/dbs-customer-profile';
import {SelectedContext} from './struct/selected-context';

export const State = t.struct({
    _persist: t.Any,
    addCustomer: AddCustomerDetail,
    configuration: Configuration,
    customerIds: CustomerIds,
    customerProfile: CustomerProfile,
    customerSearch: CustomerSearch,
    dbsCustomerProfile: DbsCustomerProfile,
    selectBusinessContact: SelectBusinessContact,
    selectedContext: SelectedContext,
    user: User
}, {
    defaultProps: {
        addCustomer: new AddCustomerDetail({}),
        configuration: new Configuration({}),
        customerIds: new CustomerIds({}),
        customerProfile: new CustomerProfile({}),
        customerSearch: new CustomerSearch({}),
        dbsCustomerProfile: new DbsCustomerProfile({}),
        selectBusinessContact: new SelectBusinessContact({}),
        selectedContext: new SelectedContext({}),
        user: new User({})
    },
    name: 'State',
    strict: true
});
